import React from "react";
import { Lesson, Appointment, Rating } from "types";

import BookAClassBanner from "./BookAClassBanner";
import BookThisClassBanner from "./BookThisClassBanner";
import BookedClassBanner from "./BookedClassBanner";
import RateThisClassBanner from "./RateThisClassBanner";

// styled
import { BannerWrapper } from "./styles";

type ClassBannerProps = {
  currentClass?: Lesson;
  appointment?: Appointment;
  rating?: Rating;
  setButtonRef: (width: number) => void;
};

const ClassBanner = ({
  currentClass,
  appointment,
  rating,
  setButtonRef,
}: ClassBannerProps) => {
  const renderBanner = () => {
    if (!currentClass) {
      // If there's no booked class, guide user to go to BookAClass page
      return <BookAClassBanner />;
    }

    // If this class is not booked yet or if this class is canceled
    if (
      (!currentClass.bookedAt && !appointment) ||
      appointment?.status === "canceled"
    )
      return (
        <BookThisClassBanner
          currentClass={currentClass}
          setButtonRef={setButtonRef}
        />
      );

    // If this class is booked and will start in the future
    if (
      (!appointment && currentClass.bookedAt) ||
      appointment?.status === "pending"
    )
      return <BookedClassBanner currentClass={currentClass} />;

    // If this class is studied or the start time is passed by
    if (appointment?.status === "completed") {
      return <RateThisClassBanner {...{ currentClass, rating }} />;
    }

    return null;
  };

  return <BannerWrapper>{renderBanner()}</BannerWrapper>;
};

export default ClassBanner;
